import { Injectable } from '@angular/core';
import { electronicFormatIBAN, friendlyFormatIBAN, isValidBIC, validateIBAN } from '~/lazy/payments/services/lib/IBANTools';

@Injectable({
  providedIn: 'root'
})
export class IbanBicSwiftService {
  public static isValidIban(iban: string | number): boolean {
    if (!iban) {
      return false;
    }

    if (typeof iban !== 'string') {
      return false;
    }
    const ibanFormatted = electronicFormatIBAN(iban);
    return validateIBAN(ibanFormatted).valid;
  }

  public static isValidBIC(bicSwift: string): boolean {
    if (!bicSwift) {
      return false;
    }

    if (typeof bicSwift !== 'string') {
      return false;
    }
    return isValidBIC(bicSwift);
  }

  public static friendlyFormatIbanOrAccount(ibanOrAccount: string): string {
    if (IbanBicSwiftService.isValidIban(ibanOrAccount)) {
      return friendlyFormatIBAN(ibanOrAccount);
    }
    return ibanOrAccount;
  }
}
